import type { AsyncSequence, Bytes, Time } from "@pdfking/tfunc"

export type FileBound = {
  readonly size: Bytes
  readonly modified: Time
  readonly stream: AsyncSequence<Blob>
}
